import { IMSVCErrors } from '@smsamiinc/catalog';
import { FormStateModel } from 'src/app/form.state.model';
import { OrgModel } from 'src/app/models/org.model';

import { TaxProfileModel } from '../../models/tax-profile';

import { IreceiptNote } from './org.action';

export class OrgStateModel {
    org: OrgModel;
    orgError: any;
    receiptOrderTypeNote: IreceiptNote;
    updateProfileForm = new FormStateModel<any>();
    taxProfileListing: TaxProfileModel[] = [];
    taxProfileErrors: IMSVCErrors;
    time_zone: string;
}
